/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../../features/addresses/Addresses.generated.js';
import { AttachmentFragmentDoc, AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import { OrganisationAvatarFragmentDoc } from '../../features/organisations/OrganisationAvatar.generated.js';
import { BuildingSubHeader_BuildingFragmentDoc } from '../../features/buildings/BuildingSubHeader.generated.js';
import { BuildingTreeItemFragmentDoc } from '../../features/buildings/trees.generated.js';
import { BuildingItem_ChildItemFragmentDoc } from '../../features/buildings/components/BuildingItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BuildingEditQueryVariables = Types.Exact<{
  docId: Types.Scalars['ID']['input'];
  expandedItemIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
}>;


export type BuildingEditQuery = { building: { __typename: 'Building', id: string, title: string, owningSystemOrganisationId: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }>, linkedCrmCompanies: Array<{ __typename: 'CrmCompany', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } | null }>, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null }, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, title: string, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, type: Types.ItemType, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null }> } };

export type BuildingEdit_ItemFragment = { __typename: 'Item', id: string, title: string, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, type: Types.ItemType, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null };

export type BuildingEdit_CreateItemsMutationVariables = Types.Exact<{
  input: Types.CreateItemsInput;
}>;


export type BuildingEdit_CreateItemsMutation = { createItems: { __typename: 'CreateItemsResult', doc: { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Quote', id: string } | { __typename: 'QuoteTemplate', id: string } | { __typename: 'Requirement', id: string }, parentItem: { __typename: 'Item', id: string, originVersionNumber?: number | null, hasChildren: boolean, children: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, pathForPdf: string, isHidden: boolean, isPriceHidden: boolean, isParentContingencyNotPreselected: boolean, isParentDecisionNotPreselected: boolean, isDecisionOption: boolean, type: Types.ItemType, title: string, decisionIsContingentItem: boolean, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathSortable: string, isParentDecisionPreselected: boolean, deletedAt?: any | null, binding: Types.ItemBinding, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, linkedQuoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null } | null }> }, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, title: string, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, type: Types.ItemType, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null }> } };

export type BuildingEdit_CreateItemsFromTemplatesMutationVariables = Types.Exact<{
  input: Types.CreateItemsFromTemplatesInput;
}>;


export type BuildingEdit_CreateItemsFromTemplatesMutation = { createItemsFromTemplates: { __typename: 'CreateItemsFromTemplatesResult', doc: { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Quote', id: string } | { __typename: 'QuoteTemplate', id: string } | { __typename: 'Requirement', id: string }, parentItem: { __typename: 'Item', id: string, originVersionNumber?: number | null, hasChildren: boolean, children: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, pathForPdf: string, isHidden: boolean, isPriceHidden: boolean, isParentContingencyNotPreselected: boolean, isParentDecisionNotPreselected: boolean, isDecisionOption: boolean, type: Types.ItemType, title: string, decisionIsContingentItem: boolean, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathSortable: string, isParentDecisionPreselected: boolean, deletedAt?: any | null, binding: Types.ItemBinding, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, linkedQuoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null } | null }> }, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, title: string, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, type: Types.ItemType, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null }> } };

export type BuildingEdit_PasteItemFromClipboardMutationVariables = Types.Exact<{
  input: Types.PasteItemInput;
}>;


export type BuildingEdit_PasteItemFromClipboardMutation = { pasteItem: { __typename: 'PasteItemResult', ok: boolean, doc: { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Quote', id: string } | { __typename: 'QuoteTemplate', id: string } | { __typename: 'Requirement', id: string }, parentItem: { __typename: 'Item', id: string, originVersionNumber?: number | null, hasChildren: boolean, children: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, pathForPdf: string, isHidden: boolean, isPriceHidden: boolean, isParentContingencyNotPreselected: boolean, isParentDecisionNotPreselected: boolean, isDecisionOption: boolean, type: Types.ItemType, title: string, decisionIsContingentItem: boolean, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathSortable: string, isParentDecisionPreselected: boolean, deletedAt?: any | null, binding: Types.ItemBinding, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, linkedQuoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null } | null }> }, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, title: string, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, type: Types.ItemType, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null }> } };

export const BuildingEdit_ItemFragmentDoc = gql`
    fragment BuildingEdit_Item on Item {
  id
  ...BuildingTreeItem
}
    ${BuildingTreeItemFragmentDoc}`;
export const BuildingEditDocument = gql`
    query BuildingEdit($docId: ID!, $expandedItemIds: [ID!]) {
  building(id: $docId, expandedItemIds: $expandedItemIds) {
    id
    title
    owningSystemOrganisationId
    buildingAddress {
      ...AddressDetails__Address
    }
    attachments {
      ...Attachment
    }
    linkedCrmCompanies {
      id
      title
      ...OrganisationAvatar
    }
    rootItem {
      id
      originVersionNumber
    }
    items {
      id
      originVersionNumber
      ...BuildingEdit_Item
    }
    ...BuildingSubHeader_Building
  }
}
    ${AddressDetails__AddressFragmentDoc}
${AttachmentFragmentDoc}
${OrganisationAvatarFragmentDoc}
${BuildingEdit_ItemFragmentDoc}
${BuildingSubHeader_BuildingFragmentDoc}`;

/**
 * __useBuildingEditQuery__
 *
 * To run a query within a React component, call `useBuildingEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingEditQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      expandedItemIds: // value for 'expandedItemIds'
 *   },
 * });
 */
export function useBuildingEditQuery(baseOptions: Apollo.QueryHookOptions<BuildingEditQuery, BuildingEditQueryVariables> & ({ variables: BuildingEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingEditQuery, BuildingEditQueryVariables>(BuildingEditDocument, options);
      }
export function useBuildingEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingEditQuery, BuildingEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingEditQuery, BuildingEditQueryVariables>(BuildingEditDocument, options);
        }
export function useBuildingEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BuildingEditQuery, BuildingEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingEditQuery, BuildingEditQueryVariables>(BuildingEditDocument, options);
        }
export type BuildingEditQueryHookResult = ReturnType<typeof useBuildingEditQuery>;
export type BuildingEditLazyQueryHookResult = ReturnType<typeof useBuildingEditLazyQuery>;
export type BuildingEditSuspenseQueryHookResult = ReturnType<typeof useBuildingEditSuspenseQuery>;
export type BuildingEditQueryResult = Apollo.QueryResult<BuildingEditQuery, BuildingEditQueryVariables>;
export const BuildingEdit_CreateItemsDocument = gql`
    mutation BuildingEdit_CreateItems($input: CreateItemsInput!) {
  createItems(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on Building {
        items {
          id
          originVersionNumber
        }
      }
    }
    parentItem {
      id
      originVersionNumber
      hasChildren
      children {
        id
        originVersionNumber
        ...BuildingItem_ChildItem
      }
    }
    items {
      id
      originVersionNumber
      ...BuildingEdit_Item
    }
  }
}
    ${BuildingItem_ChildItemFragmentDoc}
${BuildingEdit_ItemFragmentDoc}`;
export type BuildingEdit_CreateItemsMutationFn = Apollo.MutationFunction<BuildingEdit_CreateItemsMutation, BuildingEdit_CreateItemsMutationVariables>;

/**
 * __useBuildingEdit_CreateItemsMutation__
 *
 * To run a mutation, you first call `useBuildingEdit_CreateItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingEdit_CreateItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingEditCreateItemsMutation, { data, loading, error }] = useBuildingEdit_CreateItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingEdit_CreateItemsMutation(baseOptions?: Apollo.MutationHookOptions<BuildingEdit_CreateItemsMutation, BuildingEdit_CreateItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildingEdit_CreateItemsMutation, BuildingEdit_CreateItemsMutationVariables>(BuildingEdit_CreateItemsDocument, options);
      }
export type BuildingEdit_CreateItemsMutationHookResult = ReturnType<typeof useBuildingEdit_CreateItemsMutation>;
export type BuildingEdit_CreateItemsMutationResult = Apollo.MutationResult<BuildingEdit_CreateItemsMutation>;
export type BuildingEdit_CreateItemsMutationOptions = Apollo.BaseMutationOptions<BuildingEdit_CreateItemsMutation, BuildingEdit_CreateItemsMutationVariables>;
export const BuildingEdit_CreateItemsFromTemplatesDocument = gql`
    mutation BuildingEdit_CreateItemsFromTemplates($input: CreateItemsFromTemplatesInput!) {
  createItemsFromTemplates(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on Building {
        items {
          id
          originVersionNumber
        }
      }
    }
    parentItem {
      id
      originVersionNumber
      hasChildren
      children {
        id
        originVersionNumber
        ...BuildingItem_ChildItem
      }
    }
    items {
      id
      originVersionNumber
      ...BuildingEdit_Item
    }
  }
}
    ${BuildingItem_ChildItemFragmentDoc}
${BuildingEdit_ItemFragmentDoc}`;
export type BuildingEdit_CreateItemsFromTemplatesMutationFn = Apollo.MutationFunction<BuildingEdit_CreateItemsFromTemplatesMutation, BuildingEdit_CreateItemsFromTemplatesMutationVariables>;

/**
 * __useBuildingEdit_CreateItemsFromTemplatesMutation__
 *
 * To run a mutation, you first call `useBuildingEdit_CreateItemsFromTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingEdit_CreateItemsFromTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingEditCreateItemsFromTemplatesMutation, { data, loading, error }] = useBuildingEdit_CreateItemsFromTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingEdit_CreateItemsFromTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<BuildingEdit_CreateItemsFromTemplatesMutation, BuildingEdit_CreateItemsFromTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildingEdit_CreateItemsFromTemplatesMutation, BuildingEdit_CreateItemsFromTemplatesMutationVariables>(BuildingEdit_CreateItemsFromTemplatesDocument, options);
      }
export type BuildingEdit_CreateItemsFromTemplatesMutationHookResult = ReturnType<typeof useBuildingEdit_CreateItemsFromTemplatesMutation>;
export type BuildingEdit_CreateItemsFromTemplatesMutationResult = Apollo.MutationResult<BuildingEdit_CreateItemsFromTemplatesMutation>;
export type BuildingEdit_CreateItemsFromTemplatesMutationOptions = Apollo.BaseMutationOptions<BuildingEdit_CreateItemsFromTemplatesMutation, BuildingEdit_CreateItemsFromTemplatesMutationVariables>;
export const BuildingEdit_PasteItemFromClipboardDocument = gql`
    mutation BuildingEdit_PasteItemFromClipboard($input: PasteItemInput!) {
  pasteItem(input: $input) {
    ok
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on Building {
        items {
          id
          originVersionNumber
        }
      }
    }
    parentItem {
      id
      originVersionNumber
      hasChildren
      children {
        id
        originVersionNumber
        ...BuildingItem_ChildItem
      }
    }
    items {
      id
      originVersionNumber
      ...BuildingEdit_Item
    }
  }
}
    ${BuildingItem_ChildItemFragmentDoc}
${BuildingEdit_ItemFragmentDoc}`;
export type BuildingEdit_PasteItemFromClipboardMutationFn = Apollo.MutationFunction<BuildingEdit_PasteItemFromClipboardMutation, BuildingEdit_PasteItemFromClipboardMutationVariables>;

/**
 * __useBuildingEdit_PasteItemFromClipboardMutation__
 *
 * To run a mutation, you first call `useBuildingEdit_PasteItemFromClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingEdit_PasteItemFromClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingEditPasteItemFromClipboardMutation, { data, loading, error }] = useBuildingEdit_PasteItemFromClipboardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingEdit_PasteItemFromClipboardMutation(baseOptions?: Apollo.MutationHookOptions<BuildingEdit_PasteItemFromClipboardMutation, BuildingEdit_PasteItemFromClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildingEdit_PasteItemFromClipboardMutation, BuildingEdit_PasteItemFromClipboardMutationVariables>(BuildingEdit_PasteItemFromClipboardDocument, options);
      }
export type BuildingEdit_PasteItemFromClipboardMutationHookResult = ReturnType<typeof useBuildingEdit_PasteItemFromClipboardMutation>;
export type BuildingEdit_PasteItemFromClipboardMutationResult = Apollo.MutationResult<BuildingEdit_PasteItemFromClipboardMutation>;
export type BuildingEdit_PasteItemFromClipboardMutationOptions = Apollo.BaseMutationOptions<BuildingEdit_PasteItemFromClipboardMutation, BuildingEdit_PasteItemFromClipboardMutationVariables>;